module.exports = __webpack_public_path__ + "static/media/comment.c92ad2b4.svg";